import { z } from 'zod';

const num = () => z.coerce.number();
const str = () => z.string();

export const StylistLeaderboardSchema = z.array(z.object({
  Month: str(),
  Store: str(),
  Stylist: str(),
  Rank: num(),
  final_score: str(),
  target_gmv_contribution_pct: str(),
  gmv_contribution_pct: str(),
  ach_pct_gmv_contribution: str(),
  target_upt: num(),
  ach_upt: num(),
  ach_pct_upt: str(),
  total_bills: num(),
  target_bills_ge_3_pct: str(),
  bills_ge_3: num(),
  bills_ge_3_pct: str(),
  ach_pct_bills_ge_3: str(),
  target_multi_cat_pct: str(),
  bills_multi_cat: num(),
  bills_multi_cat_pct: str(),
  ach_pct_multi_cat: str(),
  target_repeat_pct: str(),
  repeat_gmv: num(),
  repeat_gmv_pct: str(),
  ach_pct_repeat: str(),
  store_total_gross_gmv: num(),
  stylist_gross_gmv: num(),
}));

export type StylistLeaderboard = z.infer<typeof StylistLeaderboardSchema>;
